// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ArrowUp = createIcon(
  <path
    clipRule="evenodd"
    d="M6.49701 10.9908C6.14553 10.6394 6.14553 10.0695 6.497 9.71805L11.3635 4.8515C11.5322 4.68272 11.7612 4.58789 11.9998 4.58789C12.2385 4.58789 12.4675 4.68271 12.6362 4.8515L17.5028 9.71804C17.8543 10.0695 17.8543 10.6394 17.5028 10.9908C17.1513 11.3423 16.5815 11.3423 16.23 10.9908L12.8999 7.66069V19.5131C12.8999 20.0102 12.4969 20.4131 11.9999 20.4131C11.5028 20.4131 11.0999 20.0102 11.0999 19.5131V7.66071L7.7698 10.9908C7.41833 11.3423 6.84848 11.3423 6.49701 10.9908Z"
    fillRule="evenodd"
  />,
);
